<template>
    <div class="event-card">event card</div>
</template>

<script>
export default {};
</script>

<style scoped></style>
